<template>
    <div>
        <div class="row" v-if="downloadUrl">
            <div class="col-md-6 col-md-offset-3">
                <a :href="downloadUrl" class="link">
                    <div class="widget-thumb widget-bg-color-white text-uppercase text-center padding-top-60 padding-bottom-60 bordered v-align">
                        <div class="widget-thumb-wrap">
                            <div class="widget-thumb-body">
                                <span style="font-size: 5em">
                                    <i class="glyphicon glyphicon-download-alt"></i>
                                </span>
                                <h3>Download documents</h3>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-md-6 col-md-offset-3">
                <div class="widget-thumb widget-bg-color-white text-uppercase text-center padding-top-60 padding-bottom-60 bordered v-align">
                    <div class="widget-thumb-wrap">
                        <div class="widget-thumb-body">
                            <spinner color="#000000"></spinner>
                            <br>
                            <p><span v-text="$lang.get('trans.processing')"></span>...</p>
                            <div class="text-left" v-html="$lang.get('trans.processing_message_1')">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from 'components/spinner/Spinner'
    export default {
        name: "archive-download",

        components: {
            Spinner
        },

        data() {
            return {
                downloadUrl: null,
                intervalId: null,
            }
        },

        methods: {
            async checkIfFileIsReadyForDownload() {

                let response = await axios.get(Sincron.steps.done)

                if (response.data.downloadUrl !== null) {
                    this.downloadUrl = response.data.downloadUrl
                    clearInterval(this.intervalId)
                }
            }
        },

        mounted() {
            this.checkIfFileIsReadyForDownload()

            this.intervalId = setInterval(() => {
                this.checkIfFileIsReadyForDownload()
            }, 5000)
        }
    }
</script>

<style scoped>

</style>